import axiosInstance from "./axiosInstance";

export const OrganizationService = {
  getOrganizationById: async (organizationId: string): Promise<any> => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/organizations/${organizationId}`
      );
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },
  getOrganizations: async (): Promise<any> => {
    try {
      const response = await axiosInstance.get(`/api/v1/organizations`);
      return response?.data;
    } catch (error: any) {
      throw error;
    }
  },
  getAllAuthsServer: async (organizationId: string): Promise<any> => {
    try {
      return await axiosInstance.get(
        `/api/v1/organizations/${organizationId}/authservers`
      );
    } catch (error) {
      throw error;
    }
  },
};
